// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__RBd5O","footer":"ModalError_footer__3fcUR"};